import { Injectable } from "@angular/core";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Transacao } from "../models/recebivel";
import { Pagination } from "../models/pagination";
import { SearchResult } from "../models/search-result";
import { HttpInterceptor } from "../../../../shared/interceptors/http-interceptor.service";
import { Oauth2TokenService } from "../../../../../services/oauth2-token.service";
import { RecebivelUpdated } from "../models/recebivel-updated";
import { environment } from "../../../../../environments/environment";

@Injectable()
export class RecebiveisService {
  recebiveisUrl: string;
  organizacaoUrl: string;
  planoSaudeUrl: string;
  medicoPlanoSaudeUrl: string;
  transacoes: Transacao[] = [];
  pagination: Pagination[] = [];

  constructor(
    private http: HttpInterceptor,
    private oauth2Token: Oauth2TokenService
  ) {
    this.recebiveisUrl = environment.api.base_url + "/api/v1/recebivel";
    this.organizacaoUrl = environment.api.base_url + "/api/v1/organizacao";
  }

  getHeaders() {
    const accessToken = this.oauth2Token.getTokens().accessToken;

    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    });
  }

  getSearchResult(params?: HttpParams): Observable<SearchResult> {
    return this.http
      .get(this.recebiveisUrl, {
        params,
        headers: this.getHeaders(),
      })
      .pipe(
        map((res: any) => res),
        map((res) => {
          let result = Array<RecebivelUpdated>();
          res.data.forEach((e) => {
            result.push(
              new RecebivelUpdated(
                e.id,
                e.transacao_recebivel_status_id,
                e.transacao_split_id,
                e.regra_divisao,
                e.valor,
                e.valor_bruto,
                e.valor_taxa_antecipacao,
                e.reembolsavel_rejeicao,
                e.parcela === null ? "À vista" : e.parcela,
                e.data_pagamento,
                e.data_pagamento_calculada,
                e.data_previsao_recebimento,
                e.vendedor.data.detalhe.data.cnpj
                  ? e.vendedor.data.detalhe.data.dono_nome
                  : e.vendedor.data.detalhe.data.nome,
                undefined,
                e.transacao.data.parcela_qtd,
                e.transacao_recebivel_created_at
                  ? e.transacao_recebivel_created_at
                  : e.created_at
              )
            );
          });

          let searchResult = new SearchResult(result, res.meta.pagination);

          return searchResult;
        }),
        map((res) => {
          let newRes = res;
          newRes.recebiveis = newRes.recebiveis.map((recebivel) => {
            switch (recebivel.transacao_recebivel_status_id) {
              case "7bc41254-53f9-4d82-83c6-e7466a956712":
                recebivel.status = "Pendente";
                break;
              case "f98796b7-2086-4307-bd33-6cc6b060aa11":
                recebivel.status = "Pago";
                break;
              case "0b4333b3-7c22-4b3b-b42c-24d78949cb15":
                recebivel.status = "Cancelado";
                break;
              case "726fab9d-20c8-468d-bea8-ac4d2fcc2ad4":
                recebivel.status = "Reembolsado";
                break;

              default:
                recebivel.status = "Pendente";
            }

            return recebivel;
          });
          return newRes;
        })
      );
  }

  getRecebivel(id: string): Observable<RecebivelUpdated> {
    let params = new HttpParams()
      .set("id", id)
      .set(
        "include",
        "transacao_cartao,transacao_taxa,vendedor,vendedor.detalhe,transacao"
      );

    let headers = this.getHeaders();

    return this.http
      .get(this.recebiveisUrl, { params: params, headers: headers })
      .pipe(
        map((res: any) => res),
        map((res) => {
          let result = Array<RecebivelUpdated>();
          res.data.forEach((e) => {
            result.push(
              new RecebivelUpdated(
                e.id,
                e.transacao_recebivel_status_id,
                e.transacao_split_id,
                e.regra_divisao,
                e.valor,
                e.valor_bruto,
                e.valor_taxa_antecipacao,
                e.reembolsavel_rejeicao,
                e.parcela === null ? "À vista" : e.parcela,
                e.data_pagamento,
                e.data_pagamento_calculada,
                e.data_previsao_recebimento,
                e.vendedor.data.detalhe.data.cnpj
                  ? e.vendedor.data.detalhe.data.dono_nome
                  : e.vendedor.data.detalhe.data.nome,
                undefined,
                e.transacao.data.parcela_qtd,
                e.transacao_recebivel_created_at
                  ? e.transacao_recebivel_created_at
                  : e.created_at
              )
            );
          });

          let searchResult = new SearchResult(result, res.meta.pagination);

          return searchResult;
        }),
        map((res) => {
          let newRes = res;
          newRes.recebiveis = newRes.recebiveis.map((transacao) => {
            switch (transacao.transacao_recebivel_status_id) {
              case "7bc41254-53f9-4d82-83c6-e7466a956712":
                transacao.status = "Pendente";
                break;
              case "f98796b7-2086-4307-bd33-6cc6b060aa11":
                transacao.status = "Pago";
                break;
              case "0b4333b3-7c22-4b3b-b42c-24d78949cb15":
                transacao.status = "Cancelado";
                break;
              case "726fab9d-20c8-468d-bea8-ac4d2fcc2ad4":
                transacao.status = "Reembolsado";
                break;

              default:
                transacao.status = "Pendente";
            }

            return transacao;
          });
          return newRes.recebiveis[0];
        })
      );
  }

  async deleteAll(data): Promise<void> {
    let headers = this.getHeaders();
    const url = `${this.recebiveisUrl}`;
    return this.http
      .delete(url, { body: data, headers })
      .toPromise()
      .then((res) => {
        let responseJson = res;
      });
  }

  getOrganizacao(params?: HttpParams): Observable<Array<any>> {
    let headers = this.getHeaders();
    let url = this.organizacaoUrl;

    return this.http
      .get(url, { params: params, headers: headers })
      .pipe(map((res: any) => res.data));
  }
}
